import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import Banner from '../../components/section-components/Banner';
import ServicesOne from '../../components/section-components/ServicesOne';
import AboutOne from '../../components/section-components/AboutOne';
import ProjectsTwo from '../../components/section-components/ProjectsTwo';
import TestimonialThree from '../../components/section-components/TestimonialThree';
import ServicesTwo from '../../components/section-components/ServicesTwo';
import TeamOne from '../../components/section-components/TeamOne';
import Counter from '../../components/section-components/Counter';
import NewsOne from '../../components/section-components/NewsOne';
import Quote from '../../components/section-components/Quote';
import FooterOne from '../../common/footer/FooterOne';
import OrlySection from "../../components/section-components/OrlySection";

// Przewiń stronę do góry z animacją
import $ from 'jquery';

const HomeOne = () => {
    $(function() {
        // Przewiń stronę do góry z animacją
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
    return (
        <>
        <HeaderOne />
        
        <Banner />
        
        <ServicesOne />
        
        <AboutOne />
        
        <ProjectsTwo />
        
        <div className='d-none d-lg-block'><TestimonialThree /></div>
        
        <ServicesTwo />
        
        <TeamOne />

        <OrlySection
            variant="split"
            imgSrc="/images/page-1_img_orly.png"
            title="DMD Group — Laureatem plebiscytu"
            lead="Z dumą informujemy, że Grupa DMD została Laureatem prestiżowego plebiscytu ORŁY Nieruchomości. Wyróżnienie przyznano na podstawie analizy ponad 5,1 mln opinii klientów, doceniając naszą jakość w budownictwie, domach na zamówienie i segmencie premium. "
            ctaText="Zobacz wyróżnienie"
            ctaHref="https://www.orlynieruchomosci.pl/profile-490053-dmd-domy"
        />
        
        <Counter />
        
        <NewsOne />

        <Quote />

        <FooterOne />
        </>
    )
}
    
export default HomeOne;